<div role="alert" class="alert {{style}}">
    <i class="jr-icon {{icon}}"></i>
    <span name="message">
        <ng-content></ng-content>
    </span>
</div>